import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-claimed-product-details-dialog',
  templateUrl: './claimed-product-details-dialog.component.html',
  styleUrls: ['./claimed-product-details-dialog.component.scss']
})
export class ClaimedProductDetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ClaimedProductDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
